/* eslint-disable import/no-anonymous-default-export */
import _ from "lodash";
import {
  SET_ACTIVE_PAGE,
  SET_AUTH_URL,
  SET_DATA,
  SET_USER_DATA,
  SET_LOADING,
  SET_SELECTED_VIEW,
  SET_WMKS_DATA,
  SET_PERMISSION,
  SET_DROP_DOWN_VALUE,
  GET_ORG_STATUS,
  SET_SELECTED_VM,
  REMOVE_SELECTED_VM,
  SET_SHUTDOWN,
  SET_SHUTDOWN_STATUS,
  SET_REBOOT_STATUS,
  SET_RESTORE_SNAP_SHOT,
  SET_CREATE_SNAP_SHOT,
  SET_ASSIGNED_ROLES,
  SET_USER_ROLES,
  SET_UPDATE_USER_ROLES,
  SET_LOADING_USER_ROLES,
  SET_START,
  SET_USER_DELETE,
  SET_NEW_USER_DATA,
  SET_SELECTED_VMWARE,
  SET_LOGGED_IN,
  SET_ASSIGNED_STATUS,
  SET_USER_ROLES_STATUS,
  SET_SITEID,
  BLOB_SIZE_DASHBOARD_SET_DATA,
  DELETE_TABLE_DATA,
  DOWLOAD_DASHBOARD_SELECT_ROWS_DATA,
  SET_DASHBOARD_UPLOAD_VALIDATION,
  SET_UPLOAD_CHUNK,
  SET_DELETE_TABLE_DATA,
  SET_DOWLOAD_DASHBOARD_SELECT_ROWS_DATA,
  SET_RENAME_FILE_DATA,
  SET_RENAME_FOLDER_DATA,
  SET_TABLE_DATA,
  SET_UPLOAD_FILE,
  SET_TOKEN_CSRF,
  CLEAR_WMKS_DETAILS,
  SIGNALR_CONNECTION,
  SET_POWER_OFF,
  SET_POWER_ON,
  SET_RESET,
  SET_COMPARE_DATA,
  SET_VMID_NOTIFICATION,
  SET_COMPARE_COLLECT_REQUEST,
  SET_ISO_LIST,
  SET_ISO_STATUS,
  SET_MOUNT_ISO,
  SET_LIST_SNAP_SHOT,
  SET_SEARCH_LIST,
  SET_UNMOUNT_ISO,
  SET_DELETE_SNAP_SHOT,
  SET_FEEDBACK_STATUS,
  SET_TENANT_DATA,
  SELECTED_TENANT,
  SET_ORG_DROPDOWN_DATA,
} from "./action";
import { IReduxAction, IState } from "./model";
import { initialState } from "./state";
import config, { ROLES_REQUIRED } from "../../common/authentication/config";
import {
  getOrgDataUtility,
  getPermissionsUtility,
} from "../../common/utility/Dashboard/utility";

export default function (
  state: IState = initialState,
  action: IReduxAction
): IState {
  switch (action.type) {
    case SET_SELECTED_VIEW: {
      return {
        ...state,
        selectedView: action.payload?.selectedView,
        vmName: action.payload?.vmName,
        plantName: action.payload?.plantName,
        activePage: action.payload?.activePage,
      };
    }
    case SET_TABLE_DATA: {
      return {
        ...state,
        tableData: action.payload,
      };
    }
    // New
    case BLOB_SIZE_DASHBOARD_SET_DATA:
      return {
        ...state,
        blobSizeDashboard: action.payload,
      };
    case SET_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    case SET_ACTIVE_PAGE: {
      return {
        ...state,
        activePage: action.payload,
      };
    }
    case SIGNALR_CONNECTION:
      return {
        ...state,
        signalR: action.payload,
      };
    case SET_DATA: {
      state.permissions?.map((per: any) => {
        action.payload?.map((org: any, index: number) => {
          if ((org && org.siteId) === (per && per.resources)) {
            org.permissions = per.permissions;
            org.index = index;
            if (org && org.vmDetails && org?.vmDetails?.length > 0) {
              _.forEach(org?.vmDetails, (value: any) => {
                value.checked = false;
                value.isIntermediate = false;
                value.isOn = value.status === "POWERED_ON" ? true : false;
              });
            }
            return org;
          }
        });
      });
      return {
        ...state,
        orgData: action.payload,
        plantName: action.payload[0]?.name,
      };
    }
    case SET_DROP_DOWN_VALUE: {
      return {
        ...state,
        selectedPlant: action.payload,
      };
    }
    case GET_ORG_STATUS: {
      return {
        ...state,
        orgDataStatus: action.payload,
      };
    }
    // case SET_COMPARE_DATA: {
    //   return {
    //     ...state,
    //     compareData: action.payload,
    //   };
    // }
    case SET_WMKS_DATA: {
      if (
        action.payload?.data !== null &&
        action.payload?.data !== undefined &&
        action.payload?.data?.host !== null &&
        action.payload?.status !== null
      ) {
        const lastPart = window.location.pathname?.split("/").pop();
        const res: any = lastPart?.replace(/%20/g, " ");
        const dataVal: any = localStorage.getItem(res);
        const value: any = JSON.parse(dataVal);
        localStorage.removeItem(value?.name);
        if (localStorage.getItem(res) === null) {
          localStorage.setItem(
            value?.name,
            JSON.stringify({
              name: value?.name,
              id: value?.id,
              orgId: value?.orgId,
              siteId: value?.siteId,
              isVmWindow: value?.isVmWindow,
              wmksData: action.payload?.data,
            })
          );
        }
      }
      return {
        ...state,
        wmksDetails: action.payload?.data
          ? action.payload?.data
          : action.payload?.response?.data,
        wmksStatus: action.payload?.status
          ? action.payload?.status
          : action.payload?.response?.status,
      };
    }
    case CLEAR_WMKS_DETAILS:
      return {
        ...state,
        wmksDetails: null,
        wmksStatus: null,
      };
    case SET_TOKEN_CSRF:
      return {
        ...state,
        csrf: action.payload?.data,
        csrfStatus: action.payload?.status,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_USER_DATA:
      return {
        ...state,
        userInfo: action.payload,
      };
    case SET_TENANT_DATA: {
      const tenantData = action.payload?.map((tenant: any) => ({
        value: tenant,
        text: tenant,
      }));
      return {
        ...state,
        tenantDropDownData: tenantData,
      };
    }
    case SELECTED_TENANT:
      return {
        ...state,
        selectedTenant: action.payload?.selectedTenant,
        selectedTenantIndex: action.payload?.selectedTenantIndex,
      };
    case SET_ORG_DROPDOWN_DATA:
    case SET_PERMISSION: {
      const isSetPermission = action.type === SET_PERMISSION;
      const tenantIndex: any = isSetPermission
        ? localStorage.getItem("tenantIndex") || 0
        : null;
      const selectedTenant: any = isSetPermission
        ? state.tenantDropDownData?.[tenantIndex]?.value
        : action.payload;

      const orgsDropDownDataVal: any =
        getOrgDataUtility(
          isSetPermission
            ? action.payload?.data?.userPermissions
            : state.userPermissions,
          selectedTenant
        ) || [];

      const filteredDataVal = orgsDropDownDataVal.filter(
        (data: any) => data.value !== config.SITE_ID
      );

      const index: any = localStorage.getItem("index") || 0;
      const value: any =
        orgsDropDownDataVal.length === 1 &&
        orgsDropDownDataVal[0].value === config.SITE_ID
          ? orgsDropDownDataVal[0].value
          : filteredDataVal[index]?.value;
      const permissions =
        isSetPermission && action.payload?.data?.userPermissions.length > 0
          ? getPermissionsUtility(
              action.payload?.data?.userPermissions,
              selectedTenant,
              orgsDropDownDataVal.length === 1 &&
                orgsDropDownDataVal[0].value === config.SITE_ID
                ? orgsDropDownDataVal
                : filteredDataVal
            )
          : action.payload?.data?.userPermissions.length === 0
          ? []
          : getPermissionsUtility(
              state.userPermissions,
              action.payload,
              orgsDropDownDataVal.length === 1 &&
                orgsDropDownDataVal[0].value === config.SITE_ID
                ? orgsDropDownDataVal
                : filteredDataVal
            );
      const baseState = {
        ...state,
        orgsDropDownData:
          orgsDropDownDataVal.length === 1 &&
          orgsDropDownDataVal[0].value === config.SITE_ID
            ? [
                {
                  text: "None",
                  value: config.SITE_ID,
                },
              ]
            : filteredDataVal,
        selectedPlant:
          orgsDropDownDataVal.length === 1 &&
          orgsDropDownDataVal[0].value === config.SITE_ID
            ? config.SITE_ID
            : value,
        activePage: index,
        permissions: permissions,
      };

      if (isSetPermission) {
        if (
          action.payload?.name !== "AxiosError" &&
          action.payload?.status === 200
        ) {
          return {
            ...baseState,
            userPermissions: action.payload?.data?.userPermissions,
            permissionStatus: action.payload.status,
          };
        } else {
          return {
            ...state,
            permissions: null,
            permissionStatus: 500,
          };
        }
      }

      return baseState;
    }
    case SET_SITEID: {
      return {
        ...state,
        siteId: action.payload,
      };
    }
    case SET_SELECTED_VM:
      state.selectedVM.push(action.payload);
      return {
        ...state,
        selectedVM: state.selectedVM,
      };
    case SET_SELECTED_VMWARE:
      return {
        ...state,
        selectedVMWare: action.payload,
      };
    case REMOVE_SELECTED_VM:
      return {
        ...state,
        selectedVM: action.payload
          ? state.selectedVM.filter((vm: any) => vm.id !== action.payload?.id) // check if this works
          : [],
        // state.selectedVM,
      };
    case SET_SHUTDOWN_STATUS:
      return {
        ...state,
        shutDownStatus: action.payload,
      };
    case SET_REBOOT_STATUS:
      return {
        ...state,
        rebootStatus: action.payload,
      };
    case SET_POWER_OFF:
      return {
        ...state,
        powerOffStatus: action.payload,
      };
    case SET_RESET:
      return {
        ...state,
        resetStatus: action.payload,
      };
    case SET_POWER_ON:
      return {
        ...state,
        powerOnStatus: action.payload,
      };
    case SET_START:
      return {
        ...state,
        rebootStatus: action.payload,
      };
    case SET_RESTORE_SNAP_SHOT:
      return {
        ...state,
        restoreSnapShotStatus: action.payload,
      };
    case SET_CREATE_SNAP_SHOT:
      return {
        ...state,
        createSnapShotStatus: action.payload,
      };
    case SET_USER_ROLES_STATUS:
      return {
        ...state,
        userRolesStatus: action.payload,
      };
    case SET_ASSIGNED_STATUS:
      return {
        ...state,
        assignedRolesStatus: action.payload,
      };
    case SET_USER_ROLES: {
      const roles = action.payload?.data?.map((role: any) => ({
        value: role.roleId,
        text: role.name,
      }));
      _.remove(roles, (n: any) => {
        return n.value === ROLES_REQUIRED.TWIN_HONEYWELL_IT[0];
      });
      const data = _.sortBy(roles, ["text"]);
      return {
        ...state,
        userRoles: data,
        loadingUserRoles: data?.length > 0 ? false : true,
      };
    }
    case SET_ASSIGNED_ROLES: {
      const user = action.payload?.data?.map((val: any) => ({
        email: val.email,
        name: val.name,
        roles: val.roles,
        userId: val.userId,
        checked: false,
      }));
      const dataUser = _.sortBy(user, ["email"]);
      return {
        ...state,
        assignedRoles: action.payload?.data?.length === 0 ? [] : dataUser,
        loadingUserRoles: dataUser?.length > 0 ? false : true,
      };
    }
    case SET_NEW_USER_DATA: {
      return {
        ...state,
        newUserData: action.payload,
      };
    }

    case SET_UPDATE_USER_ROLES: {
      return {
        ...state,
        modifyUserResponse: action.payload,
      };
    }
    case SET_LOADING_USER_ROLES:
      return {
        ...state,
        loadingUserRoles: action.payload,
      };
    case SET_USER_DELETE:
      return {
        ...state,
        deleteResponse: action.payload,
      };
    case SET_UPLOAD_FILE:
      return {
        ...state,
        uploadfile: action.payload,
      };
    // New
    case DELETE_TABLE_DATA:
      return {
        ...state,
        deleteResponseDashboard: action.payload,
      };
    case SET_DELETE_TABLE_DATA:
      return {
        ...state,
        deleteDashboardRes: action.payload,
        // message: "File deleted successfully!",
        // error: null,
        // status: "Deleted",
        // statuscode: 200
      };
    case DOWLOAD_DASHBOARD_SELECT_ROWS_DATA:
      return {
        ...state,
        downloadDashboardSelectRow: action.payload,
      };
    case SET_DOWLOAD_DASHBOARD_SELECT_ROWS_DATA:
      return {
        ...state,
        setDownloadRes: action.payload,
      };
    case SET_RENAME_FILE_DATA:
      return {
        ...state,
        renameRes: action.payload,
      };
    case SET_RENAME_FOLDER_DATA:
      return {
        ...state,
        renameFolderRes: action.payload,
      };
    case SET_DASHBOARD_UPLOAD_VALIDATION:
      return {
        ...state,
        uploadValidationRes: action.payload,
      };
    case SET_UPLOAD_CHUNK:
      return {
        ...state,
        chunkUploadRes: action.payload,
      };
    case SET_VMID_NOTIFICATION:
      return {
        ...state,
        vmIdNotification: action.payload,
      };
    case SET_COMPARE_COLLECT_REQUEST:
      return {
        ...state,
        compareRequestStatusData: action.payload,
      };
    case SET_ISO_LIST:
      return {
        ...state,
        isoList: action.payload,
      };
    case SET_ISO_STATUS:
      return {
        ...state,
        isoListStatus: action.payload,
      };
    case SET_MOUNT_ISO:
      return {
        ...state,
        isoMountStatus: action.payload?.status,
        isoMountMessage:
          action.payload?.status === 200
            ? action.payload?.data
            : action.payload?.response?.data,
      };
    case SET_UNMOUNT_ISO:
      return {
        ...state,
        isoUnmountStatus: action.payload?.status,
        isoUnmountMessage:
          action.payload?.status === 200
            ? action.payload?.data
            : action.payload?.response?.data,
      };

    case SET_LIST_SNAP_SHOT: {
      const snapShotList =
        action.payload?.data?.values?.length > 0 &&
        action.payload.data.values?.map((item: any) => {
          return {
            dateCreated: item?.dateCreated,
            name: item?.name,
            id: item?.id,
            isChecked: false,
          };
        });
      return {
        ...state,
        snapShotList:
          action.payload?.data?.values?.length > 0 ? snapShotList : [],
        snapShotListStatus: action.payload?.status,
      };
    }
    case SET_SEARCH_LIST:
      return {
        ...state,
        searchList: action.payload.message,
        searchStatus: action.payload.statuscode,
      };
    case SET_DELETE_SNAP_SHOT:
      return {
        ...state,
        deleteSnapShotStatus: action.payload?.status,
      };
    case SET_FEEDBACK_STATUS:
      return {
        ...state,
        feedBackStatus:
          action.payload?.status !== undefined ? action.payload?.status : 0,
      };
    default:
      return state;
  }
}
